import React, { useState, useEffect } from 'react';
import { withRouter, useLocation } from 'react-router-dom';
import TextEditor from "../../../../../../../Util/TextEditor/TextEditor.js";
import './SendEmail.css';
import { config } from "../../../../../../../config";
import { messages } from "../../../../../../../messages";
import axiosApi from './../../../../../../../core/interceptor/interceptor';
import _ from 'lodash';
import { stripHtml } from '../../../../../../../Util/helper.js';
import { AsyncPaginate } from 'react-select-async-paginate';

function SendEmail(props) {
  const [emailData, setEmailData] = useState({
    subject: '',
    body: '',
    recipients_id: 0,
    type: 'email',
    is_league: false,

  })
  const [errors, setErrors] = useState({
    message: '',
    recepientUsers: '',
    subject: '',
  });

  const [childKey, setChildKey] = useState(1);
  const search = useLocation().search;
  const [leagueId, setLeagueId] = useState(new URLSearchParams(search).get('leagueId'));
  const mailId = new URLSearchParams(search).get('mailId');
  const [userListOption, setUserListOption] = useState([]);
  const [edit, setEdit] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedLeagues, setSelectedLeague] = useState([]);
  const [selectedTeams, setSelectedTeams] = useState([]);
  const [teamListOption, setTeamListOption] = useState([]);
  const [leagueListOption, setLeagueListOption] = useState([]);
  const [leagueIds, setLeagueIds] = useState([]);
  const [teamIds, setTeamIds] = useState([]);
  const [selectedSeason, setSelectedSeason] = useState(null);
  const [recipientKey, setRecipientKey] = useState(Math.floor(Math.random() * 90000) + 10000)
  const [teamKey, setTeamKey] = useState(Math.floor(Math.random() * 90000) + 10000)
  // eslint-disable-next-line
  const [seasonFilter, setSeasonFilter] = useState({ page: 1, search: '' });
  // eslint-disable-next-line
  const [leagueFilter, setLeagueFilter] = useState({ page: 1, search: '' });
  // eslint-disable-next-line
  const [userFilter, setUserFilter] = useState({ page: 1, search: '' });
  const [attachments, setAttachments] = useState('');

  const getMessageDetail = () => {
    axiosApi.get(`${config.apiUrl}/messages/email/${mailId}`)
      .then((response) => {
        let data = response.data.data;
        setEmailData({
          subject: data.subject,
          message: data.message,
          recipients_id: data.recepient_id,
          type: 'email',
          is_league: false,
        });

      })
      .catch((err) => {

      })
  }

  useEffect(() => {
    if (props.location && props.location.state) {
      setEdit(true);
      setEmailData({ ...emailData, ...props.location.state, });
    }
    if (mailId !== null) {
      props.setArchieve();
      getMessageDetail();
    }

    if (leagueId === null) {
      if (props.location && props.location.state && props.location.state.leagueId) {
        setLeagueId(Number(props.location.state.leagueId));
      }
    }
    //eslint-disable-next-line
  }, []);

  const handleFormChange = (event) => {
    setEmailData((previousEmailData) => ({
      ...previousEmailData,
      [event.target.name]: event.target.value,
    }));
  }

  const handleValidation = () => {
    let errorArr = {};
    let formIsValid = true;
    /***** name validation ******/
    if (!stripHtml(emailData['body'])) {
      formIsValid = false;
      errorArr["message"] = messages && messages.emailBody;
    }
    if (!emailData.subject) {
      formIsValid = false;
      errorArr['subject'] = messages && messages.empty_email_subject;
    }
    if (selectedUsers.length === 0 && !leagueId) {
      formIsValid = false;
      errorArr["recepientUsers"] = messages && messages.selectRecipients
    }
    setErrors(errorArr);
    return formIsValid;
  }

  const sendEmailLeague = (sendTo = '') => {
    if (handleValidation()) {
      const bodyData = new FormData();
      const data = {
        subject: emailData.subject,
        body: emailData.body,
        type: 'email',
        league_id: leagueId,
        recipients_type: sendTo,
        is_league: true,
      };
      bodyData.append('data', JSON.stringify(data));
      axiosApi.post(`${config.apiUrl}/messages/email`, bodyData)
        .then(() => {
          setEmailData({
            body: '',
            recipients_id: '',
            subject: '',
            type: 'email',
            is_league: false,
          });
          setChildKey(prev => prev + 1);
        });
    }
  }

  const sendEmail = async () => {
    let allUserOnly = false;
    if (selectedUsers?.length && !selectedTeams?.length && !selectedLeagues?.length && !selectedLeagues?.length) {
      const allSelected = selectedUsers.find(x => x.name === 'All');
      if (allSelected) {
        allUserOnly = true;
      }
    }

    let data = { ...emailData };
    if (!allUserOnly) {
      if (Array.isArray(selectedUsers)) {
        if (selectedUsers.some(user => user.id === 0)) {
          const users = await getUsersByLeague(0, '', true);
          data.recipients_id = _.uniqBy(users.map(user => user.id)).join();
        } else {
          data.recipients_id = selectedUsers.map(user => user.id).join();
        }
      }
    } else {
      data.all_user = true;
    }
    
    data.filename = attachments?.name;
    const bodyData = new FormData();
    bodyData.append('data', JSON.stringify(data));
    bodyData.append('file', attachments);
    bodyData.append('filename', attachments?.name);
    
    if (handleValidation()) {
      axiosApi.post(`${config.apiUrl}/messages/email`, bodyData)
        .then(() => {
          setEmailData({
            body: '',
            recipients_id: '',
            subject: '',
            type: 'email',
            is_league: false,
          });
          setSelectedSeason(null);
          setSelectedLeague([]);
          setSelectedTeams([])
          setRecipientKey(Math.floor(Math.random() * 90000) + 10000)
          setTeamKey(Math.floor(Math.random() * 90000) + 10000)
          setSelectedUsers([]);
          setAttachments('');
          setChildKey(prev => prev + 1);
        })
        .catch((err) => {
          console.error(err);
        })
    }
  }

  const customStyles = {
    menu: (provided, state) => ({
      ...provided,
      fontSize: "13px",
      lineHeight: "16px",
      wordBreak: "break-word",
    }),
    option: (provided, state) => ({
      ...provided,
      cursor: "pointer"
    })
  }

  const getAllSeasons = async (page_, searchString) => {
    const seasons = await axiosApi.get(`${config.apiUrl}/seasons`, { params: { page: page_, search: searchString } });
    return seasons.data.data;
  }

  const getLeaguesBySeason = async (page_, searchString, noLimit) => {
    const seasons = await axiosApi.get(`${config.apiUrl}/misc/leagues/${selectedSeason?.id || 0}`, { params: { page: page_, search_string: searchString , noLimit, sortColumn: 'id' } });
    return seasons.data.data;
  }

  const getTeamByLeague = async (page_, searchString, noLimit) => {
    let leagueId = '';
    if (selectedLeagues.some(team => team.id === 0)) {
      leagueId = _.uniqBy(leagueIds.map(league => league.id)).join();
    } else {
      leagueId = selectedLeagues.map(league => league.id).join();
    }
    const teams = await axiosApi.get(`${config.apiUrl}/misc/teams`, { params: { page: page_, search_string: searchString, leagueId, noLimit, sortColumns: 'id' } });
    return teams.data.data;
  }

  const getUsersByLeague = async (page_, searchString, noLimit) => {
    let teamId = '';
    if (selectedTeams.some(team => team.id === 0)) {
      teamId = _.uniqBy(teamIds.map(team => team.id)).join();
    } else {
      teamId = selectedTeams.map(team => team.id).join();
    }
    let leagueId = '';
    if (selectedLeagues.some(team => team.id === 0)) {
      leagueId = _.uniqBy(leagueIds.map(league => league.id)).join();
    } else {
      leagueId = selectedLeagues.map(league => league.id).join();
    }
    const users = await axiosApi.get(`${config.apiUrl}/seasons/all/user`, { params: { page: page_, search: searchString, teamId, leagueId , noLimit} });
    return users.data.data;
  }

  const loadOptionsSeason = async (searchQuery, loadedOptions, { page }) => {
    setSeasonFilter((prev) => {
      if (prev.search !== searchQuery) {
        return { search: searchQuery, page };
      }
      return { search: searchQuery, page: page + 1 };
    });
    const seasons = await getAllSeasons(page, searchQuery);
    return {
      options: seasons,
      hasMore: seasons.length === 20,
      additional: {
        page: page + 1,
      },
    };
  };

  const loadOptionsLeague = async (searchQuery, loadedOptions, { page }) => {
    setLeagueFilter((prev) => {
      if (prev.search !== searchQuery) {
        return { search: searchQuery, page };
      }
      return { search: searchQuery, page: page + 1 };
    });
    const leagues = await getLeaguesBySeason(page, searchQuery);
    const leaguesLength = [...leagues].length;
    if (!loadedOptions?.length && leagues?.length) {
      leagues.unshift({ id: 0, name: 'All' });
    }
    setLeagueListOption([...loadedOptions, ...leagues])
    return {
      options: leagues,
      hasMore: leaguesLength === 20,
      additional: {
        page: page + 1,
      },
    };
  };

  const loadOptionsTeam = async (searchQuery, loadedOptions, { page }) => {
    setLeagueFilter((prev) => {
      if (prev.search !== searchQuery) {
        return { search: searchQuery, page };
      }
      return { search: searchQuery, page: page + 1 };
    });
    const teams = await getTeamByLeague(page, searchQuery);
    const teamsLength = [...teams].length;
    if (!loadedOptions?.length && teams?.length) {
      teams.unshift({ id: 0, name: 'All' });
    }
    setTeamListOption([...loadedOptions, ...teams]);
    return {
      options: teams,
      hasMore: teamsLength === 20,
      additional: {
        page: page + 1,
      },
    };
  };

  const loadOptionsUser = async (searchQuery, loadedOptions, { page }) => {
    setUserFilter((prev) => {
      if (prev.search !== searchQuery) {
        return { search: searchQuery, page };
      }
      return { search: searchQuery, page: page + 1 };
    });
    const users = await getUsersByLeague(page, searchQuery);
    const usersLength = [...users].length;
    if (!loadedOptions?.length && users?.length) {
      users.unshift({ id: 0, name: 'All' });
    }
    setUserListOption([...loadedOptions, ...users]);
    return {
      options: users,
      hasMore: usersLength === 20,
      additional: {
        page: page + 1,
      },
    };
  };

  const onFileChange = (e) => {
    if (e && e.target && e.target.files) {
      setAttachments(e.target.files[0]);
    }
  }

  const getAndSetAllLeagues = async () => {
    const leagues = await getLeaguesBySeason(0, '', true);
    setLeagueIds(leagues);
  }

  const getAndSetAllTeams = async () => {
    const teams = await getTeamByLeague(0, '', true);
    setTeamIds(teams);
  }

  return <>
    <div className="inner-wrapper">
      <div className="flex-blk subject-field">
        <label htmlFor="email_subject">Email Subject</label>
        <input type="text" id="email_subject" name="subject" value={emailData.subject} onChange={handleFormChange} />
        {!(emailData.subject || '').trim() && <span className="error">{errors['subject']}</span>}
      </div>
      <div className="flex-blk body-field">
        <label htmlFor="email_body">Email Body</label>
        <TextEditor
          type='email'
          key={childKey}
          value={emailData.body}
          name="body" edit={edit} onChange={(body) => handleFormChange({ target: { name: 'body', value: body } })}
        />
        {!stripHtml(emailData.body) && <span className="error">{errors['message']}</span>}
      </div>
      {leagueId !== null ? <div className="flex-blk body-field">
        <label>Send To</label>
        <button className="search-btn" onClick={() => { sendEmailLeague('captain') }}>Captains</button>
        <button className="search-btn" onClick={() => { sendEmailLeague('league') }}>Entire League</button>
      </div>
        : <>
          <div className="flex-blk">
            <div className="recipint-search-wrapper">
              <div className="recipint-search-blk">
                <label>Select Season</label>
                <AsyncPaginate
                  isClearable={true}
                  value={selectedSeason}
                  loadOptions={loadOptionsSeason}
                  getOptionValue={(option) => option.id}
                  getOptionLabel={(option) => option.name}
                  onChange={(option) => {
                    setSelectedSeason(option);
                    setSelectedLeague([]);
                    setSelectedTeams([])
                    setRecipientKey(Math.floor(Math.random() * 90000) + 10000)
                    setTeamKey(Math.floor(Math.random() * 90000) + 10000)
                    setSelectedUsers([]);
                  }}
                  placeholder="Search Season"
                  additional={{
                    page: 1,
                  }}
                  debounceTimeout={1000}
                  styles={customStyles}
                  noOptionsMessage={() => "No Seasons Found."}
                  className="multivalue-dropdown"
                />
              </div>
              <div className="recipint-search-blk">
                <label>Select League</label>
                <AsyncPaginate
                  key={selectedSeason?.id}
                  isClearable={true}
                  value={selectedLeagues}
                  loadOptions={loadOptionsLeague}
                  getOptionValue={(option) => option.id}
                  getOptionLabel={(option) => option.name}
                  onChange={(option) => {
                    setSelectedTeams([])
                    setSelectedUsers([]);
                    if (option.length) {
                      if (option.some(league => league.id === 0)) {
                        setSelectedLeague([{ id: 0, name: 'All' }]);
                        getAndSetAllLeagues();
                      } else {
                        setSelectedLeague(option.filter(league => league.id));
                      }
                    } else {
                      setSelectedLeague([]);
                    }
                    setRecipientKey(Math.floor(Math.random() * 90000) + 10000)
                    setTeamKey(Math.floor(Math.random() * 90000) + 10000)
                  }}
                  placeholder="Search League"
                  additional={{
                    page: 1,
                  }}
                  debounceTimeout={1000}
                  styles={customStyles}
                  isMulti={true}
                  noOptionsMessage={() => "No Leagues Found."}
                  className="multivalue-dropdown"
                />
              </div>
              <div className="recipint-search-blk">
                <label>Select Team</label>
                <AsyncPaginate
                  key={teamKey}
                  isClearable={true}
                  value={selectedTeams}
                  loadOptions={loadOptionsTeam}
                  getOptionValue={(option) => option.id}
                  getOptionLabel={(option) => option.name}
                  onChange={(option) => {
                    setSelectedUsers([]);
                    setRecipientKey(Math.floor(Math.random() * 90000) + 10000)
                    if (option.length) {
                      if (option.some(team => team.id === 0)) {
                        setSelectedTeams([{ id: 0, name: 'All' }]);
                        getAndSetAllTeams();
                      } else {
                        setSelectedTeams(option.filter(team => team.id));
                      }
                    } else {
                      setSelectedTeams([]);
                    }
                  }}
                  placeholder="Search Team"
                  additional={{
                    page: 1,
                  }}
                  debounceTimeout={1000}
                  isMulti={true}
                  styles={customStyles}
                  noOptionsMessage={() => "No Team Found."}
                  className="multivalue-dropdown"
                />
              </div>
              <div className="recipint-search-blk">
                <label>Select Email Recipients</label>
                <AsyncPaginate
                  key={recipientKey}
                  value={selectedUsers}
                  loadOptions={loadOptionsUser}
                  getOptionValue={(option) => option.id}
                  getOptionLabel={(option) => option.name}
                  onChange={(option) => {
                    if (option.length) {
                      if (option.some(user => user.id === 0)) {
                        setSelectedUsers([{ id: 0, name: 'All' }]);
                      } else {
                        setSelectedUsers(option.filter(user => user.id));
                      }
                    } else {
                      setSelectedUsers([]);
                    }
                  }}
                  placeholder="Search User"
                  additional={{
                    page: 1,
                  }}
                  debounceTimeout={1000}
                  styles={customStyles}
                  isMulti={true}
                  noOptionsMessage={() => "No Users Found."}
                  className="multivalue-dropdown"
                />
                {!selectedUsers?.length && <span className="error">{errors['recepientUsers']}</span>}
              </div>
              <div className="buttonblock cs-attach-btn">
                <label htmlFor="add-img" className='buttonStyle changeimagebutton btn'> Add Attachment
                  <input type='file' className='siteInfoImageUploader' onChange={(e) => onFileChange(e)} id="add-img" ></input>
                </label>
                <p title={attachments && attachments?.name}>{attachments && attachments?.name}</p>
              </div>
            </div>
          </div>
          <button className="search-btn" onClick={() => sendEmail()}>Send Email</button>
        </>
      }
    </div>
  </>
}

export default withRouter(SendEmail);